import { skipsEmbeddedCashierTermsDisabledGate, type EmbeddedCashierVariant } from './checkoutDialogTracking';

type GetIsPayDisabledParams = {
  isSubmitting: boolean;
  isWaitingForTermsData: boolean;
  embeddedCashierVariant: EmbeddedCashierVariant | undefined;
  isTermsRequirementMet: boolean;
  isBelowMinimumPreStepActive: boolean;
  isBelowMinimum: boolean;
  isDepositLimitFullyReached: boolean;
  amountExceedsDepositLimit: boolean;
};

function getIsPayDisabled({
  isSubmitting,
  isWaitingForTermsData,
  embeddedCashierVariant,
  isTermsRequirementMet,
  isBelowMinimumPreStepActive,
  isBelowMinimum,
  isDepositLimitFullyReached,
  amountExceedsDepositLimit,
}: GetIsPayDisabledParams): boolean {
  if (isSubmitting) {
    return true;
  }

  if (isWaitingForTermsData) {
    return true;
  }

  if (!isBelowMinimumPreStepActive && !skipsEmbeddedCashierTermsDisabledGate(embeddedCashierVariant) && !isTermsRequirementMet) {
    return true;
  }

  if (isBelowMinimum) {
    return true;
  }

  if (isDepositLimitFullyReached) {
    return true;
  }

  if (amountExceedsDepositLimit) {
    return true;
  }

  return false;
}

export { getIsPayDisabled, type GetIsPayDisabledParams };
